import { STORAGE_KEY, STORYGRAPH_PILL_STYLE, type TransferData } from '../../constants'
import { maybeDownloadCover } from '../../utils/download'
import { getUserOptions } from '../settings'
import { parseReadmooPage } from './parser'

const READMOO_BUTTON_ID = 'readmoo-port-to-sg-btn'

function openStoryGraphSearch (data: TransferData): void {
  const query = data.isbn || data.title
  const url = `https://app.thestorygraph.com/browse?search_term=${encodeURIComponent(query)}`
  if (typeof GM_openInTab === 'function') {
    GM_openInTab(url, { active: true })
  } else {
    window.open(url, '_blank')
  }
}

function isReadmooBookPage (): boolean {
  return /^\/book\/\d+/.test(window.location.pathname)
}

function getButtonHost (): HTMLElement | null {
  return document.querySelector<HTMLElement>('h1[itemprop="name"], .book-title h1, .book-info h1, .product-info h1, main h1, h1')
}

export function injectReadmooPortButton (): void {
  if (!isReadmooBookPage()) return

  const host = getButtonHost()
  if (!host) return

  const existing = document.getElementById(READMOO_BUTTON_ID) as HTMLAnchorElement | null
  if (existing) {
    if (existing.previousElementSibling !== host) host.insertAdjacentElement('afterend', existing)
    return
  }

  const btn = document.createElement('a')
  btn.id = READMOO_BUTTON_ID
  btn.href = '#'
  btn.textContent = 'Port to StoryGraph'
  btn.style.cssText = `${STORYGRAPH_PILL_STYLE} margin:6px 0 0;`
  host.insertAdjacentElement('afterend', btn)

  btn.addEventListener('click', (event) => {
    event.preventDefault()
    const data = parseReadmooPage()
    const options = getUserOptions()

    if (options.downloadReadmooCover) {
      maybeDownloadCover(data.title, data.coverUrl)
    }

    GM_setValue(STORAGE_KEY, JSON.stringify(data))
    openStoryGraphSearch(data)
  })
}
